import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';

import {
  selectors as localeSelectors,
  actions as localeActions,
} from '../../store/locale';

class LocaleSelector extends Component {
  static propTypes = {
    setLocale: PropTypes.func.isRequired,
    setQuestionLocale: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    questionLocale: PropTypes.string.isRequired,
    isQuestion: PropTypes.bool,
  };

  static defaultProps = {
    isQuestion: false,
  };

  onLocaleChange = (e, locale) => {
    e.preventDefault();

    if (this.props.isQuestion) {
      this.props.setQuestionLocale(locale);
    } else {
      this.props.setLocale(locale);
    }
  };

  render() {
    const { isQuestion } = this.props;
    const locale = isQuestion ? this.props.questionLocale : this.props.locale;

    const locales = {
      fi: <FormattedMessage id="locale-fi" defaultMessage="Suomi" />,
      sv: <FormattedMessage id="locale-sv" defaultMessage="Svenska" />,
      en: <FormattedMessage id="locale-en" defaultMessage="English" />,
    };

    return (
      <div className="dropdown d-flex align-items-center mr-3">
        <a
          href="#"
          className="nav-link dropdown-toggle d-flex align-items-center"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <img
            className="locale-icon mr-3"
            src={`/assets/images/locales/${locale}.png`}
            alt={locale}
          />

          {locales[locale]}
        </a>

        <div className="dropdown-menu">
          {Object.keys(locales).map(l => (
            <a
              key={l}
              href="#"
              className="dropdown-item"
              onClick={e => this.onLocaleChange(e, l)}
            >
              {locales[l]}
            </a>
          ))}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    locale: localeSelectors.locale(state),
    questionLocale: localeSelectors.questionLocale(state),
  }),
  dispatch =>
    bindActionCreators(
      {
        setLocale: localeActions.set,
        setQuestionLocale: localeActions.setQuestion,
      },
      dispatch
    )
)(LocaleSelector);
